var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.orderLists,"items-per-page":5},on:{"click:row":function($event){return _vm.tableRowClick(_vm.orderLists.id)}}})}
var staticRenderFns = []

export { render, staticRenderFns }